import { FixMeLater } from "types/FixMeLaterType"
import i18n from "../../i18n"

export interface TargetField {
    key: string,
    value: string,
    FIELD: { [index: string]: TargetFieldField },
    RULE: { [index: string]: TargetFieldRule }
}

interface TargetFieldRule {
    key: string,
    value: string
    FilterType: string
    CodeType: string
}

interface TargetFieldField {
    key: string,
    value: string
}

export function createTargetFields(): FixMeLater {
    var object: { [index: string]: TargetField } = {}

    object.CUSTOMERS = {
        key: "Customers",
        value: i18n.t('customer.customers'),
        FIELD: {},
        RULE: {}
    }
    object.PRODUCTS = {
        key: "Products",
        value: i18n.t('product.products'),
        FIELD: {},
        RULE: {}
    }
    object.DISTRIBUTOR = {
        key: "Distributor",
        value: i18n.t('distributor.distributor'),
        FIELD: {},
        RULE: {}
    }

    //#region Customers 
    // FIELDS
    object.CUSTOMERS.FIELD.id = {
        key: "id",
        value: i18n.t('common.id')
    }
    object.CUSTOMERS.FIELD.CustomerName = {
        key: "CustomerName",
        value: i18n.t('target-field.customer-name')
    }
    object.CUSTOMERS.FIELD.AddressLine1 = {
        key: "AddressLine1",
        value: i18n.t('target-field.address-line-1')
    }
    //RULES
    object.CUSTOMERS.RULE.id = {
        key: "id",
        value: i18n.t('common.id'),
        FilterType: "Equal",
        CodeType: "id"
    }
    object.CUSTOMERS.RULE.SalesRouteIds = {
        key: "SalesRouteIds",
        value: i18n.t('target-field.sales-route-ids'),
        FilterType: "Contains",
        CodeType: "SalesRoute"
    }
    object.CUSTOMERS.RULE.BusinessTypeId = {
        key: "BusinessTypeId",
        value: i18n.t('target-field.business-type-id'),
        FilterType: "Equal",
        CodeType: "BusinessType"
    }
    object.CUSTOMERS.RULE.DistributionChannelId = {
        key: "DistributionChannelId",
        value: i18n.t('target-field.distribution-channel-id'),
        FilterType: "Equal",
        CodeType: "DistributionChannel"
    }
    object.CUSTOMERS.RULE.DivisionId = {
        key: "DivisionId",
        value: i18n.t('target-field.division-id'),
        FilterType: "Equal",
        CodeType: "Division"
    }
    object.CUSTOMERS.RULE.PaymentTermsId = {
        key: "PaymentTermsId",
        value: i18n.t('target-field.payment-terms-id'),
        FilterType: "Equal",
        CodeType: "PaymentTerms"
    }
    object.CUSTOMERS.RULE.SalesGroupId = {
        key: "SalesGroupId",
        value: i18n.t('target-field.sales-group-id'),
        FilterType: "Equal",
        CodeType: "SalesGroup"
    }
    object.CUSTOMERS.RULE.SalesOfficeId = {
        key: "SalesOfficeId",
        value: i18n.t('target-field.sales-office-id'),
        FilterType: "Equal",
        CodeType: "SalesOffice"
    }
    object.CUSTOMERS.RULE.SalesOrganisationId = {
        key: "SalesOrganisationId",
        value: i18n.t('target-field.sales-organisation-id'),
        FilterType: "Equal",
        CodeType: "SalesOrganisationId"
    }
    object.CUSTOMERS.RULE.SalesPolicyId = {
        key: "SalesPolicyId",
        value: i18n.t('target-field.sales-policy-id'),
        FilterType: "Equal",
        CodeType: "SalesPolicy"
    }
    object.CUSTOMERS.RULE.TradeChannelId = {
        key: "TradeChannelId",
        value: i18n.t('target-field.trade-channel-id'),
        FilterType: "Equal",
        CodeType: "TradeChannel"
    }
    object.CUSTOMERS.RULE.SubTradeChannelId = {
        key: "SubTradeChannelId",
        value: i18n.t('target-field.sub-trade-channel-id'),
        FilterType: "Equal",
        CodeType: "SubTradeChannel"
    }
    object.CUSTOMERS.RULE.TradeNameId = {
        key: "TradeNameId",
        value: i18n.t('target-field.trade-name-id'),
        FilterType: "Equal",
        CodeType: "TradeName"
    }
    object.CUSTOMERS.RULE.CallLocation = {
        key: "CallLocation",
        value: i18n.t('target-field.call-location'),
        FilterType: "Equal",
        CodeType: "CallLocation"
    }
    object.CUSTOMERS.RULE.Active = {
        key: "Active",
        value: i18n.t('common.active'),
        FilterType: "Bool",
        CodeType: "Active"
    }
    object.CUSTOMERS.RULE.City = {
        key: "City",
        value: i18n.t('target-field.city'),
        FilterType: "TitleOrUpperCase",
        CodeType: "City"
    }
    object.CUSTOMERS.RULE.Region = {
        key: "Region",
        value: i18n.t('target-field.region'),
        FilterType: "Equal",
        CodeType: "Regi"
    }
    object.CUSTOMERS.RULE.Country = {
        key: "Country",
        value: i18n.t('target-field.country'),
        FilterType: "Equal",
        CodeType: "Country"
    }
    object.CUSTOMERS.RULE.PostCode = {
        key: "PostCode",
        value: i18n.t('target-field.post-code'),
        FilterType: "Equal",
        CodeType: "PostCode"
    }
    object.CUSTOMERS.RULE.Suburb = {
        key: "Suburb",
        value: i18n.t('target-field.suburb'),
        FilterType: "Equal",
        CodeType: "Suburb"
    }
    object.CUSTOMERS.RULE.DeliveringPlant = {
        key: "DeliveringPlant",
        value: i18n.t('target-field.delivering-plant'),
        FilterType: "Equal",
        CodeType: "DeliveringPlant"
    }
    object.CUSTOMERS.RULE.TransportationZone = {
        key: "TransportationZone",
        value: i18n.t('target-field.transportation-zone'),
        FilterType: "Equal",
        CodeType: "TransportationZone"
    }
    object.CUSTOMERS.RULE.CustomerGroupId = {
        key: "CustomerGroupId",
        value: i18n.t('target-field.customer-group-id'),
        FilterType: "Equal",
        CodeType: "CustomerGroup"
    }
    object.CUSTOMERS.RULE.AccountGroupId = {
        key: "AccountGroupId",
        value: i18n.t('target-field.account-group-id'),
        FilterType: "Equal",
        CodeType: "AccountGroup"
    }
    object.CUSTOMERS.RULE.DoorCount = {
        key: "DoorCount",
        value: i18n.t('target-field.doorcount'),
        FilterType: "Equal",
        CodeType: "DoorCount"
    }
    object.CUSTOMERS.RULE.SegmentationId = {
        key: "SegmentationId",
        value: i18n.t('target-field.segmentation-id'),
        FilterType: "Equal",
        CodeType: "Segmentation"
    }

    //#endregion

    //#region Products
    //Fields
    object.PRODUCTS.FIELD.id = {
        key: "id",
        value: i18n.t('common.id'),
    }
    object.PRODUCTS.FIELD.ProductName = {
        key: "ProductName",
        value: i18n.t('product.product-name')
    }
    //Rules
    object.PRODUCTS.RULE.id = {
        key: "id",
        value: i18n.t('common.id'),
        FilterType: "Equal",
        CodeType: "id"
    }
    object.PRODUCTS.RULE.AvailableToSalesOrg = {
        key: "AvailableToSalesOrg",
        value: i18n.t('target-field.available-to-sales-org'),
        FilterType: "Contains",
        CodeType: "SalesOrganisationId"
    }
    object.PRODUCTS.RULE.PackSizeId = {
        key: "PackSizeId",
        value: i18n.t('target-field.pack-size-id'),
        FilterType: "Equal",
        CodeType: "ProductPackSize"
    }
    object.PRODUCTS.RULE.PackTypeId = {
        key: "PackTypeId",
        value: i18n.t('target-field.pack-type-id'),
        FilterType: "Equal",
        CodeType: "ProductPackType"
    }
    object.PRODUCTS.RULE.PackageId = {
        key: "PackageId",
        value: i18n.t('target-field.package-id'),
        FilterType: "Equal",
        CodeType: "ProductPackage"
    }
    object.PRODUCTS.RULE.BrandId = {
        key: "BrandId",
        value: i18n.t('target-field.brand-id'),
        FilterType: "Equal",
        CodeType: "ProductBrand"
    }
    object.PRODUCTS.RULE.CategoryId = {
        key: "CategoryId",
        value: i18n.t('category.category-id'),
        FilterType: "Equal",
        CodeType: "ProductCategory"
    }
    object.PRODUCTS.RULE.FlavorId = {
        key: "FlavorId",
        value: i18n.t('target-field.flavor-id'),
        FilterType: "Equal",
        CodeType: "ProductFlavor"
    }
    object.PRODUCTS.RULE.Active = {
        key: "Active",
        value: i18n.t('common.active'),
        FilterType: "Bool",
        CodeType: "Active"
    }
    //#endregion

    //#region Distibutor
    // FIELDS
    object.DISTRIBUTOR.FIELD.id = {
        key: "id",
        value: i18n.t('common.id')
    }
    object.DISTRIBUTOR.FIELD.CustomerName = {
        key: "CustomerName",
        value: i18n.t('target-field.customer-name')
    }
    object.DISTRIBUTOR.FIELD.AddressLine1 = {
        key: "AddressLine1",
        value: i18n.t('target-field.address-line-1')
    }
    //RULES
    object.DISTRIBUTOR.RULE.id = {
        key: "id",
        value: i18n.t('common.id'),
        FilterType: "Equal",
        CodeType: "id"
    }
    object.DISTRIBUTOR.RULE.SalesRouteIds = {
        key: "SalesRouteIds",
        value: i18n.t('target-field.sales-route-ids'),
        FilterType: "Contains",
        CodeType: "SalesRoute"
    }
    object.DISTRIBUTOR.RULE.BusinessTypeId = {
        key: "BusinessTypeId",
        value: i18n.t('target-field.business-type-id'),
        FilterType: "Equal",
        CodeType: "BusinessType"
    }
    object.DISTRIBUTOR.RULE.DistributionChannelId = {
        key: "DistributionChannelId",
        value: i18n.t('target-field.distribution-channel-id'),
        FilterType: "Equal",
        CodeType: "DistributionChannel"
    }
    object.DISTRIBUTOR.RULE.DivisionId = {
        key: "DivisionId",
        value: i18n.t('target-field.division-id'),
        FilterType: "Equal",
        CodeType: "Division"
    }
    object.DISTRIBUTOR.RULE.PaymentTermsId = {
        key: "PaymentTermsId",
        value: i18n.t('target-field.payment-terms-id'),
        FilterType: "Equal",
        CodeType: "PaymentTerms"
    }
    object.DISTRIBUTOR.RULE.SalesGroupId = {
        key: "SalesGroupId",
        value: i18n.t('target-field.sales-group-id'),
        FilterType: "Equal",
        CodeType: "SalesGroup"
    }
    object.DISTRIBUTOR.RULE.SalesOfficeId = {
        key: "SalesOfficeId",
        value: i18n.t('target-field.sales-office-id'),
        FilterType: "Equal",
        CodeType: "SalesOffice"
    }
    object.DISTRIBUTOR.RULE.SalesOrganisationId = {
        key: "SalesOrganisationId",
        value: i18n.t('target-field.sales-organisation-id'),
        FilterType: "Equal",
        CodeType: "SalesOrganisationId"
    }
    object.DISTRIBUTOR.RULE.SalesPolicyId = {
        key: "SalesPolicyId",
        value: i18n.t('target-field.sales-policy-id'),
        FilterType: "Equal",
        CodeType: "SalesPolicy"
    }
    object.DISTRIBUTOR.RULE.TradeChannelId = {
        key: "TradeChannelId",
        value: i18n.t('target-field.trade-channel-id'),
        FilterType: "Equal",
        CodeType: "TradeChannel"
    }
    object.DISTRIBUTOR.RULE.SubTradeChannelId = {
        key: "SubTradeChannelId",
        value: i18n.t('target-field.sub-trade-channel-id'),
        FilterType: "Equal",
        CodeType: "SubTradeChannel"
    }
    object.DISTRIBUTOR.RULE.TradeNameId = {
        key: "TradeNameId",
        value: i18n.t('target-field.trade-name-id'),
        FilterType: "Equal",
        CodeType: "TradeName"
    }
    object.DISTRIBUTOR.RULE.CallLocation = {
        key: "CallLocation",
        value: i18n.t('target-field.call-location'),
        FilterType: "Equal",
        CodeType: "CallLocation"
    }
    object.DISTRIBUTOR.RULE.Active = {
        key: "Active",
        value: i18n.t('common.active'),
        FilterType: "Bool",
        CodeType: "Active"
    }
    object.DISTRIBUTOR.RULE.City = {
        key: "City",
        value: i18n.t('target-field.city'),
        FilterType: "TitleOrUpperCase",
        CodeType: "City"
    }
    object.DISTRIBUTOR.RULE.Region = {
        key: "Region",
        value: i18n.t('target-field.region'),
        FilterType: "Equal",
        CodeType: "Region"
    }
    object.DISTRIBUTOR.RULE.Country = {
        key: "Country",
        value: i18n.t('target-field.country'),
        FilterType: "Equal",
        CodeType: "Country"
    }
    object.DISTRIBUTOR.RULE.PostCode = {
        key: "PostCode",
        value: i18n.t('target-field.post-code'),
        FilterType: "Equal",
        CodeType: "PostCode"
    }
    object.DISTRIBUTOR.RULE.Suburb = {
        key: "Suburb",
        value: i18n.t('target-field.suburb'),
        FilterType: "Equal",
        CodeType: "Suburb"
    }
    object.DISTRIBUTOR.RULE.DeliveringPlant = {
        key: "DeliveringPlant",
        value: i18n.t('target-field.delivering-plant'),
        FilterType: "Equal",
        CodeType: "DeliveringPlant"
    }
    object.DISTRIBUTOR.RULE.TransportationZone = {
        key: "TransportationZone",
        value: i18n.t('target-field.transportation-zone'),
        FilterType: "Equal",
        CodeType: "TransportationZone"
    }
    object.DISTRIBUTOR.RULE.CustomerGroupId = {
        key: "CustomerGroupId",
        value: i18n.t('target-field.customer-group-id'),
        FilterType: "Equal",
        CodeType: "CustomerGroup"
    }
    object.DISTRIBUTOR.RULE.AccountGroupId = {
        key: "AccountGroupId",
        value: i18n.t('target-field.account-group-id'),
        FilterType: "Equal",
        CodeType: "AccountGroup"
    }
    object.DISTRIBUTOR.RULE.DoorCount = {
        key: "DoorCount",
        value: i18n.t('target-field.doorcount'),
        FilterType: "Equal",
        CodeType: "DoorCount"
    }
    object.DISTRIBUTOR.RULE.SegmentationId = {
        key: "SegmentationId",
        value: i18n.t('target-field.segmentation-id'),
        FilterType: "Equal",
        CodeType: "Segmentation"
    }
    //#endregion


    return Object.freeze(object)
}